import React, {useState, useEffect, } from 'react';
import { goOneApp } from '../../utils/helper';
import { sendEvent } from '../../api/nativeBridge';
import styled from "styled-components";
import foOneImage from "../../images/main/fo_one.svg";
import { updateSplashImage } from '../../utils/helper';
import { blendColors } from '../../utils/colorUtils';


const FOHomeBenefitPopup: React.FC = () => {
    let whiteColor = 'rgba(255, 255, 255, 1)'
    const [bgColor, setBGColor] = useState(whiteColor);

    const titleMainStyle = {
        color: 'var(--color-text-neutral_6, #181A1B)',
        fontSize: 32,
        fontWeight: 700,
        lineHeight: '36.40px',
    };
    
    const titleSubStyle = {
        color: 'var(--color-container-primary, #E6007E)',
        fontSize: 32,
        fontWeight: 700,
        lineHeight: '36.40px',
    };

    const infoTextStyle = {
        color: '#66707A',
        fontSize: 16,
        fontWeight: 500,
        lineHeight: '24px',
    };

    const infoTextBoldStyle = {
        color: 'var(--color-text-neutral_4, #181A1B)',
        fontSize: 16,
        fontWeight: 700,
        lineHeight: '24px',
    };

    let handleButtonClick = async () => {
        goOneApp();
    }

    const finishApp = () => {
        sendEvent('APP_FINISH', {})
    }

    const fetchInit = async () => {
        updateSplashImage();
    }


    useEffect(() => {
        fetchInit();
    }, []);

    return (
        <>
        <div
            style={{
                backgroundColor: bgColor,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
            }}
            >

            <div 
                style={{
                    marginTop: '80px',
                    padding: '0',
                    display: 'flex', 
                    flexDirection: 'column', 
                    alignItems: 'center'
                }}
                >

                <div 
                    style={{
                        width: '100%', 
                        height: '100%', 
                        flexDirection: 'column', 
                        justifyContent: 'flex-start', 
                        alignItems: 'center', 
                        display: 'inline-flex'
                    }}>
                    <div 
                        style={{
                            alignSelf: 'stretch', 
                            textAlign: 'center'
                        }}>
                        <span style={titleMainStyle}>U+멤버십 앱<br/></span>
                        <span style={titleSubStyle}>종료 안내</span>
                    </div>
                    <div 
                        style={{
                            textAlign: 'center',
                            marginTop: '12px',
                        }}>
                        <span style={infoTextStyle}>
                            2025년 11월 3일(월)부로<br/>U+멤버십 앱 서비스가 종료되었습니다.</span>
                    </div>
                    <div 
                        style={{
                            textAlign: 'center',
                            marginTop: '10px',
                        }}>
                        <span style={infoTextBoldStyle}>
                            멤버십 혜택은 그대로,<br/>앞으로 U+one 앱에서<br/>더 편리하게 이용하실 수 있습니다.</span>
                    </div>
                </div>

            </div>

            <div 
                style={{
                    padding: '0 20px 0 20px',
                    boxSizing: 'border-box',
                    width: '100%',
                    marginTop: '32px',
                }}
                >
                <img
                    src={foOneImage}
                    alt="fo one"
                    style={{
                        width: '100%',
                        display: 'block',        // img 기본 inline 여백 제거
                        borderRadius: 12,       // rounded 대체
                        objectFit: 'cover'      // 필요 시
                    }}
                />
            </div>

            <div
                style={{
                    padding: '0 20px 0 20px',
                    boxSizing: 'border-box',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    position: 'relative',
                    width: '100%',
                    height: '120px',
                    marginTop: '60px',
                }}
                >
                <StyledButtonPrimary
                    type="button"
                    aria-label="U+one 앱으로 이동"
                    onClick={handleButtonClick}
                >
                    <StyledTextspan>U+one 앱으로 이동</StyledTextspan>
                </StyledButtonPrimary>
                <StyledButtonNeutral
                    type="button"
                    aria-label="U+멤버십 앱 종료"
                    onClick={finishApp}
                >
                    <StyledText01span>U+멤버십 앱 종료</StyledText01span>
                </StyledButtonNeutral>
  
            </div>

        </div>
        </>
    );
};

const StyledTextspan = styled.span`
  color: var(--color-text-onPrimary, white);
  font-size: 16px;
  font-weight: 600;
  word-wrap: break-word;
`;

const StyledText01span = styled.span`
  color: var(--color-text-neutral_4, #181A1B);
  font-size: 16px;
  font-weight: 600;
  word-wrap: break-word;
`;

// styled native buttons
const StyledButtonPrimary = styled.button`
  width: 100%;
  border-radius: 12px;
  background: var(--color-container-primary, #E6007E);
  color: var(--color-text-onPrimary, #ffffff);
  border: none;
  padding: 14px 16px;
  font-size: 16px;
  font-weight: 600;
  -webkit-tap-highlight-color: transparent;
  outline: none;
  transition: box-shadow 0.08s ease, opacity 0.08s ease;

  &:active {
    box-shadow: inset 0 0 0 9999px rgba(0,0,0,0.1);
  }

`;

const StyledButtonNeutral = styled.button`
  width: 100%;
  border-radius: 12px;
  background: var(--color-surface-neutral, #F2F4F6);
  color: var(--color-text-neutral_4, #181A1B);
  border: none;
  padding: 14px 16px;
  font-size: 16px;
  font-weight: 600;
  -webkit-tap-highlight-color: transparent;
  outline: none;
  margin-top: 6px;
  transition: box-shadow 0.08s ease, opacity 0.08s ease;

  &:active {
    box-shadow: inset 0 0 0 9999px rgba(0,0,0,0.1);
  }
`;

const StyledButtonPrimary1 = styled.button`
  width: 100%;
  border-radius: 12px;
  background: var(--color-container-primary, #E6007E);
  color: var(--color-text-onPrimary, #ffffff);
  border: none;
  padding: 14px 16px;
  font-size: 16px;
  font-weight: 600;
  -webkit-tap-highlight-color: transparent;
  outline: none;
  transition: background-color 0.1s ease;

  &:active {
    background-color: ${blendColors('#E6007E', '#000000', 0.1)};
  }

`;

const StyledButtonNeutral1 = styled.button`
  width: 100%;
  border-radius: 12px;
  background: var(--color-surface-neutral, #F2F4F6);
  color: var(--color-text-neutral_4, #181A1B);
  border: none;
  padding: 14px 16px;
  font-size: 16px;
  font-weight: 600;
  -webkit-tap-highlight-color: transparent;
  outline: none;
  margin-top: 6px;
  transition: background-color 0.1s ease;

  &:active {
    background-color: ${blendColors('#F2F4F6', '#000000', 0.1)};
  }
`;


export default FOHomeBenefitPopup;
